import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconPreview = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 1H5C5.55312 1 6 1.44687 6 2V3H3V2C3 1.44687 3.44688 1 4 1ZM6 4V14C6 14.5531 5.55312 15 5 15H1C0.446875 15 0 14.5531 0 14V12.1531C0 11.0719 0.29375 10.0094 0.85 9.08125C1.27813 8.36875 1.55313 7.575 1.65625 6.75L1.89062 4.875C1.95312 4.375 2.37813 4 2.88438 4H6ZM13.1187 4C13.6219 4 14.05 4.375 14.1125 4.875L14.3438 6.75C14.4469 7.575 14.7219 8.36875 15.15 9.08125C15.7062 10.0094 16 11.0719 16 12.1531V14C16 14.5531 15.5531 15 15 15H11C10.4469 15 10 14.5531 10 14V4H13.1187ZM10 2C10 1.44687 10.4469 1 11 1H12C12.5531 1 13 1.44687 13 2V3H10V2ZM9 4V9H7V4H9Z" fill={color} />
        </svg>
    </div>
);

export default IconPreview;
